// Turns a real category title like "LED BULB SERIES" into a premium
// collection heading "LED Bulb Collection" — a display-only transform of
// real data (title-case + swap the trailing "SERIES" for "Collection"),
// not invented copy. Handles the LED acronym so it doesn't get
// title-cased into "Led".
export function categoryDisplayName(title) {
  if (!title) return "";

  const words = title.trim().split(/\s+/);
  const last = words[words.length - 1];
  const base = last.toUpperCase() === "SERIES" ? words.slice(0, -1) : words;

  const cased = base.map((w) =>
    w.toUpperCase() === "LED" ? "LED" : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
  );

  return [...cased, "Collection"].join(" ");
}

export default categoryDisplayName;
